var React = require('react');

function Pencil (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"fill":"#2185D0","fillRule":"nonzero","d":"M33 0c20 0 31 12 33 36v158l-33 57-33-57V36C2 12 13 0 33 0zm24 193H11l22 42 24-42zM33 11c-16 0-22 7-22 21h46c0-14-8-21-24-21zm24 32H11v140h46V43z","key":1})]);
}

Pencil.defaultProps = {"viewBox":"0 0 66 251"};

module.exports = Pencil;

Pencil.default = Pencil;
